import { Container, Stack, Typography } from '@mui/material';

import { tApp } from '@frontend/locales';

export const UnAuthView = () => {
  return (
    <Container>
      <Stack
        spacing={2}
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        <Typography variant="h4">{tApp.app.unAuth.header()}</Typography>
        <Typography variant="h5">{tApp.app.unAuth.message()}</Typography>
      </Stack>
    </Container>
  );
};
